var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},[_c('div',{},[_c('b-row',{staticClass:"media-slider-main",attrs:{"no-gutters":""}},[_c('b-col',{attrs:{"lg":"12"}},[_c('b-skeleton-img',{attrs:{"aspect":"1:0.4"}})],1)],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }